import React from 'react'
import './Loader.css'
interface props{

}

const Loader : React.FC<props> = () => {
  return (
    <div className='loader'>Loading...</div>
  )
}

export default Loader